module.exports = __webpack_public_path__ + "static/media/commerical-7.c76a4395.jpg";